import { createTheme } from "@mui/material";
import { amber, teal } from "@mui/material/colors";

// hello
const tiTheme = createTheme({
  palette: {
    primary: {
      main: "#145CE6",
      light: "",
      dark: "",
      contrastText: "",
    },
    secondary: amber,
  },
  shape: {},
  typography: {},

  zIndex: {
    appBar: 0,
  },
});
export default tiTheme;
